<template>
  <div class="uploadPageWrap">
    <div class="uploadPage" v-show="!flag">
      <div class="uploadPage_toptitle">
        <div class="uploadPage_toptitlebox">
          <van-icon
            v-show="!share"
            class="uploadPage_back"
            name="arrow-left"
            @click="backClick"
          />
          <div class="uploadPage_empty" v-show="share"></div>
          <div class="details_top_title" style="color: #000" v-if="isGlShare">發布</div>

          <div class="details_top_title" v-else>
            <div to="/postPage" class="dt link" @click="$router.replace('/postPage')">
              <div>动态</div>
              <div class="link_icon"></div>
            </div>
            <div class="rich link" v-if="!$store.state.isMobile && !isEdit" @click="goRich2">
              <div>长文</div>
            </div>
            <div class="rich link" v-if="$store.state.isMobile && !isEdit" @click="goRich">
              <div>长文</div>
            </div>
          </div>

          <span v-show="this.$store.state.system !== 'android'"></span>
          <van-icon
            name="close"
            v-show="
              this.$store.state.system == 'android' &&
              applets != 'xcx' &&
              !$store.state.isXcx &&
              this.$store.state.isInGame && this.$store.state.gameType != 4
            "
            @click="closeCommunity"
          />
        </div>
      </div>
      <div class="commonBg"></div>
      <!-- <van-field class="title_input" v-if="isGlShare" v-model="tz_title" label="" type="textarea" maxlength="30"
        placeholder="给你的涂装起个响亮的名字吧" rows="1" autosize />
      <van-field ref="uploadinput" id="uploadinput" class="desc_input"
        :style="isGlShare ? 'margin-top: 0;font-size: .28rem' : ''" autofocus="autofocus" :class="uploadPageinput"
        v-model="value" rows="2" autosize maxlength="5000" label="" type="textarea"
        :placeholder="isGlShare ? '简单介绍一下这套机兵涂装吧' : '写下你的想法...'" show-word-limit @focus="inputFocus"
        @click="handleSelection" @input="handleSelection" /> -->
      <div class="uploadPage_topicbox" v-if="false">
        <div class="uploadPage_topic" v-for="item in myTopic" :key="item.id">
          {{ item.subjectName }}
          <div class="uploadPage_topic_icon" @click="deteltopic(item)" v-if="!isGlShare"></div>
        </div>
      </div>
      <!-- 展示上传的文件box -->
      <div class="imglistbox" v-if="upImgList !== 0 || upVideoList.length !== 0" style="margin-top: 1.7rem">
        <a name="firstAnchor"></a>
        <!-- 图片九宫格 -->
        <div class="imglist" v-for="item in upImgList" :key="item.id">
          <span class="remove_btn" @click="removeFile(item.id, 'img')" v-if="!isGlShare"></span>
          <!-- <img :src="item.mindetail" @click="checkImg(item.mindetail)" /> -->
          <img :preview="item.id" :src="item.path" alt="" @click="checkImg" />
        </div>
        <!-- 视频 -->
        <div class="imglist videoList" v-for="item in upVideoList" :key="item.id">
          <span class="remove_btn" @click="removeFile(item.id, 'video')" v-if="!isGlShare"></span>
          <img @click="goUrl(item.path)" :data-video="item.path"
            src="@/assets/img/rich/cover.jpg"
            v-if="$store.state.isInGame && $store.state.isU3d">
          <video v-else :src="item.path" alt="" @click="checkImg" autoplay controls style="max-height: 3.8rem;"></video>

        </div>
        <div class="uploadbox" v-show="upImgList.length < 9 && upVideoList < 1" v-if="!isGlShare">
          <input v-show="upImgList.length < 1 && upVideoList < 1" ref="addimg3" :type="file1"  :accept="$store.state.isUpVideoShow ? '' : 'image/*'" class="file-btn" @change="addFile($event)" />
          <input v-show="upImgList.length > 0 || upVideoList > 0" :accept="fileAccept" ref="addimg3" :type="file1" class="file-btn" @change="addFile($event)" />
          <!-- 龙之国和第七史诗隐藏视频 -->
          <p class="upload_tip" v-show="upImgList.length < 1 && upVideoList < 1">{{$store.state.isUpVideoShow ? '图片/视频' : '图片'}}</p>
        </div>
      </div>
      <!-- </div> -->
      <div class="pad_emjoy" v-if="emojiFlag && $padFalg != 'other'">
        <div class="pad_emjoybox">
          <emjoy
            ref="upload_emjoy"
            @pushvalue="pushvalue"
            @deleteClick="deleteClick"
          ></emjoy>
        </div>
      </div>
      <div class="uploadPage_select_partition" @click="gotopic(true)" :class="emojiFlag && $padFalg == 'other' ? 'uploadPage_select_partition_emoji' : ''">
        <p>選擇發布位置</p>
        <div class="uploadPage_select_partition_name" :class="!changePartitionFlag?'mr':''">
          <span v-if="partitionInfo.item">
            <img v-if="partitionInfo.item.logo" :src="partitionInfo.item.logo" alt="">
            <!-- <img v-else src="//media.zlongame.com/media/pictures/cn/community/1705460260139/avatar/1.png" alt=""> -->
            <p>{{partitionInfo.item.partitionName}}</p>
          </span>
          <img v-if="changePartitionFlag" src="@/assets/img/go_icon.png" alt="">
        </div>
      </div>
      <div class="uploadPage_bottom" ref="bottombox" :class="emojiFlag && $padFalg == 'other' ? 'uploadPage_bottom_emoji' : ''">
        <div class="uploadPage_bottombox" :class="bottombox_class" :style="isGlShare ? 'justify-content: flex-end' : ''">
          <div class="uploadPage_bottom_left" v-if="!isGlShare">
            <div v-show="topicFlag" class="uploadPage_bottom_topic" @click="gotopic(true)" v-if="false"></div>
            <div class="uploadPage_bottom_expression" :class="emojiFlag ? 'uploadPage_bottom_expressioncur' : ''"
              @mousedown="emojiClick"></div>
            <div class="picture_icon" v-show="upImgList.length < 9 && upVideoList.length < 1">
              <input ref="addimg3" :type="file1" accept="image/*" class="file-btn" @change="addFile($event, 'bottom')" />
            </div>
            <div class="video_icon picture_icon" v-show="upVideoList.length < 1 && upImgList.length < 1 && $store.state.isUpVideoShow">
              <input ref="addimg3" :type="file1" accept="video/*" class="file-btn" @change="addFile($event, 'bottom')" />
            </div>
          </div>
          <div class="uploadPage_bottom_btn" :class="!postingFlag ? 'gray' : ''" @click="releaseClick">
            發布
          </div>
        </div>
        <emjoy
          ref="upload_emjoy"
          v-if="emojiFlag && $padFalg == 'other'"
          @pushvalue="pushvalue"
          @deleteClick="deleteClick"
        ></emjoy>
      </div>
    </div>
    <div class="check-img" v-if="checkImgSrc" @click="checkImg('')">
      <img :src="checkImgSrc" alt="" />
    </div>
    <!-- <topic v-if="flag" @gotopic="gotopic" @addmyTopic="addmyTopic"></topic> -->
    <partition v-if="flag" @gotopic="gotopic" @selectPartition="selectPartition"></partition>
    <sideRight v-if="$padFalg != 'other'"></sideRight>
    <div class="loading_box" v-show="loadingFlag">
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>

<script>
import topic from "./page/topic.vue";
import partition from "./page/partition.vue";
import successful from "../tip/successful.vue";

import { Dialog, Toast } from "vant";
import lrz from "lrz";
import get from "../../api/get";
import qs from "qs";
import * as _code from "../../utils/code";
import sideRight from "@/components/sideRight";
import emjoy from "../emjoy/emjoy.vue";

import getPad from "@/utils/getPad";

export default {
  name: "uploadPage",
  components: { topic, partition,successful, sideRight, emjoy },
  data() {
    return {
      clientHeight2: 0,
      selection: null,
      range: null,
      textNode: null,
      rangeStartOffset: null,
      emjoTime: 0,
      checkImgSrc: "",
      applets: window.user.weixcode ? "xcx" : "",
      loadingFlag: false,
      brush: true,
      share: false, //判断是否直接从游戏内分享进入
      uploadPageinput: "",
      // shareimg: "",
      bottombox_class: "", //底部动态样式
      topicFlag: true,
      myTopic: [],
      uploadPage_bottom_ios: "",
      emojiFlag: false,
      flag: false,
      msg: "uploadPage",
      value: "",
      miniImg: false,
      upImgList: [], //添加完成的图片队列
      upVideoList: [], // 完成上传的视频队列
      file1: "file", //input数据类型
      imgArry: {}, //当前图片对象
      videoArray: {}, // 当前视频对象
      qaFlag: /^(test|qa)-/.test(location.hostname),
      Bucket: "",
      Region: "",
      allowPrefix: "",
      protocol: "https:",
      isios: Boolean(navigator.userAgent.match(/iphone|ipod|iOS/gi)),
      postingFlag: "",
      tz_title: "",
      isGlShare: 0, // 钢岚涂装分享控制页面元素显示标志
      uploadType: 1, // 1-图片 2- 视频
      isEdit: false, // 是否编辑帖子
      partitionInfo:{
        id:'',
        item:'',
      },
      changePartitionFlag:true,
      // editPostId: 
      // fileAccept: 'image/*,video/*'
    };
  },
  computed: {
    fileAccept() {
      if (this.upImgList.length > 0) {
        return "image/*";
      } else if (this.upVideoList.length > 0) {
        return "video/*";
      } else {
        return "file";
      }
    },
  },
  watch: {
    value(ne, ol) {
      if (ne.length > 4500) {
        this.uploadPageinput = "uploadPageinput";
      } else {
        this.uploadPageinput = "";
      }
    },
  },
  mounted() {
   
    this.$preview.on("close", (e, item) => {
      //图片大图关闭事件
      if (this.$store.state.system == "iphone") {
        window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=0";
      }
    });
    // this.$nextTick(() => {
    //   this.$refs.uploadinput.focus();
    // });
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (this.$route.query.subjectName) {
      let obj = {
        subjectName: this.$route.query.subjectName,
        id: this.$route.query.id,
        subjectType: this.$route.query.subjectType,
      };
      this.addmyTopic(obj);
    }
    if (
      this.$route.query.imgUrl ||
      this.$route.query.text
    ) {
      this.shareinit();
    }
    if(this.myTopic[0]){
      this.partitionInfo.item = this.myTopic[0];
      this.partitionInfo.item.partitionName = this.myTopic[0].subjectName;
      this.partitionInfo.item.id = this.myTopic[0].id;
      this.partitionInfo.item.logo = '';
    }
    this.postingFlag = this.$store.state.postingFlag;
    this.initDraft()
    this.initEdit()
    // let a = replaceAssetsByHost("https://snspic-1251257918.cos.ap-shanghai.myqcloud.com/")
  },
  methods: {
    selectPartition(item){
      this.flag = false;
      this.partitionInfo.item = item;
    },
    initEdit() {
      const postId = this.$route.query.postId
      if (postId == undefined) return
      this.isEdit = true
      get.getDetail(postId).then((res) => {
        if (res.data.code == 0) {
          var _data = res.data.data;
          // 给编辑器赋值
          this.value = _data.content
          this.myTopic = _data.subjects
          this.upImgList = _data.pictures
          this.upVideoList = _data.videos

        } else if (res.data.code == 1004) {
          this.flag = false;
        } else {
          // this.errorMessage(res.data);
        }
      });
    },
    initDraft() {
      const drafts = localStorage.getItem('drafts_dt')
      if (drafts !== null) {
        let drafts_dt = JSON.parse(drafts)
        this.value = drafts_dt.value
        this.upImgList = drafts_dt.upImgList
        this.upVideoList = drafts_dt.upVideoList
        this.myTopic = drafts_dt.topics
        this.partitionInfo.item = drafts_dt.partitionInfo
        // 获取标题字数
        // this.titleLength = this.publishObj.title.length;

      }
    },
    goRich2() {
      this.$router.replace('/rich2')
    },
    goRich() {
      if (this.value.trim() !== "" || this.upImgList.length > 0 || this.upVideoList.length > 0) {
        Dialog.confirm({
          message: "确认要切换吗？<br>切换后，已编辑的内容将不会保存。",
          cancelButtonText: "留下",
          confirmButtonText: "切换",
        })
          .then(() => {
            this.$router.replace("/rich");
            localStorage.removeItem('drafts_dt')
          })
          .catch(() => { });
      } else {
        this.$router.replace("/rich");
      }

      //  是否保存草稿

    },

    goUrl(url) {
      var count = 3000;
      var pace = 50;
      let isQa = /^(test|qa)-/.test(location.hostname);
      let pageUrl = 'https://' + (isQa ? 'qa-' : '') + 'www.sugarfungame.com/actv/communityVideo/index.html?id='
      setTimeout(function () {
        try {
          window.gotoUrl(pageUrl + url);
        } catch (err) {
          count = count - pace;
          if (count >= 0) {
            arguments.callee();
          }
        }
      }, pace);
    },
    //表情包功能模块
    deleteClick() {
      let _this = this;
      let len = `${_this.value.match(
        /\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,3}_(\d){1,2}_(\d{1,3})\]$/g,
        function (a) {
          return a;
        }
      )}`.length;
      if (len == 4) {
        _this.value = _this.value.slice(0, -1);
      } else {
        _this.value = _this.value.slice(0, -len);
      }
    },
    //input获取焦点事件
    inputFocus(objectsAre, id) {
      if (this.$store.state.system !== "iphone") {
        this.emojiFlag = false;
      }
    },
    pushvalue(imgvalue) {
      let _this = this;
      let elInput = document.getElementById("uploadinput");
      let startPos = elInput.selectionStart;
      let endPos = elInput.selectionEnd;
      if (endPos === 0 && _this.value == "") {
        _this.value = this.$refs.upload_emjoy.changeValue(imgvalue);
      } else {
        let txt = _this.value;
        let result =
          txt.substring(0, startPos) +
          this.$refs.upload_emjoy.changeValue(imgvalue) +
          txt.substring(endPos);
        _this.value = result;
      }
      if (this.$padFalg != "other") {
        this.emojiClick();
      }
      console.log(startPos, _this.value.length, endPos);

      if (this.$store.state.system == "iphone") {
        _this.$nextTick(() => {
          elInput.focus();
          elInput.selectionStart = startPos + _this.value.length;
          elInput.selectionEnd = startPos + _this.value.length;
        });
      }
    },
    handleSelection() {
      if (this.$refs.upload_emjoy) {
        this.$refs.upload_emjoy.handleSelection();
      }
    },

    checkImg(val) {
      if (this.$store.state.system == "iphone") {
        window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=1";
      }
    },
    shareinit() {
      // 游戏内的分享到社区
      const gameType = this.$store.state.gameType;
      if (this.$route.query.para === 'GaragePaintingCode' || this.$route.query.imgUrl || this.$route.query.text) {
        console.log('111')
        this.isGlShare = true;
        if (this.$route.query.imgUrl) {
          this.share = true;
          if (this.$route.query.imgUrl) {
            if (location.host.includes('zlongame')) {
              this.imgArry.detail = this.$route.query.imgUrl.replace(
                "snspic-1251257918.cos.ap-shanghai.myqcloud.com/",
                "snspic.zlongame.com/"
              );
            } else if (location.host.includes('sugarfungame')) {
              this.imgArry.detail = this.$route.query.imgUrl.replace(
                "snspic-1251257918.cos.ap-shanghai.myqcloud.com/",
                "snspic.sugarfungame.com/"
              );
            } else if (location.host.includes('tentree-games')) {
              this.imgArry.detail = this.$route.query.imgUrl.replace(
                "snspic-jp-1251257918.cos.ap-tokyo.myqcloud.com/",
                "snspic.tentree-games.com/"
              );
              this.imgArry.detail = this.$route.query.imgUrl.replace(
                "snspic-sgp-1251257918.cos.ap-singapore.myqcloud.com/",
                "snspic.tentree-games.com/"
              );

            }
            this.imgArry.path = this.imgArry.detail
            this.imgArry.id = this.upImgList.length;
            this.upImgList.push(this.imgArry);
            this.$previewRefresh();
            this.imgArry = {};
          }
          // if (this.$route.query.text) {
          //   this.value = this.$route.query.text;
          // }
          
          this.partitionInfo.item = {};
          this.partitionInfo.item.id = "1";
          this.partitionInfo.item.partitionName = "機甲塗装庫";
          this.changePartitionFlag = false;
          return
        }
      }

      // 这部分功能在港澳台没有，先注释掉
      // 如果有imgUrl 和 text 说明是游戏分享进来的 
      // if (this.$route.query.imgUrl || this.$route.query.text) {
      //   this.share = true;
      //   if (this.$route.query.imgUrl) {
      //     if (location.host.includes('zlongame')) {
      //       this.imgArry.detail = this.$route.query.imgUrl.replace(
      //         "snspic-1251257918.cos.ap-shanghai.myqcloud.com/",
      //         "snspic.zlongame.com/"
      //       );
      //     } else if (location.host.includes('sugarfungame')) {
      //       this.imgArry.detail = this.$route.query.imgUrl.replace(
      //         "snspic-1251257918.cos.ap-shanghai.myqcloud.com/",
      //         "snspic.sugarfungame.com/"
      //       );
      //     }
      //     this.imgArry.path = this.imgArry.detail
      //     this.imgArry.id = this.upImgList.length;
      //     this.upImgList.push(this.imgArry);
      //     this.$previewRefresh();
      //     // this.imgList.push(item);
      //     this.imgArry = {};
      //   }
      //   if (this.$route.query.text) {
      //     this.value = this.$route.query.text;
      //   }


      //   // 根据游戏判断话题
      //   let topicObj = {}
      //   if (gameType === 1) {
      //     topicObj = {
      //       id: 27,
      //       subjectName: "分享瞬间",
      //     };
      //     this.partitionInfo.item = {};
      //     this.partitionInfo.item.id = "27";
      //     this.partitionInfo.item.partitionName = "分享瞬间";
      //   } else if (gameType === 2) {
      //     topicObj = {
      //       id: 9,
      //       subjectName: "分享",
      //     }
      //     this.partitionInfo.item = {};
      //     this.partitionInfo.item.id = "9";
      //     this.partitionInfo.item.partitionName = "分享";
      //     this.changePartitionFlag = false;
      //   }
      //   if (topicObj == '') return
      //   this.myTopic.push(topicObj);
      // }
      // 这部分功能在港澳台没有，先注释掉

    },
    base64ToFile(urlData, fileName) {
      let arr = urlData.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], fileName, { type: mime });
    },
    imageToBase64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/jpeg" + ext);
      return dataURL;
    },
    backClick() {
      // this.$router.go(-1);
      const _this = this
      if (this.isEdit) {
        this.$router.go(-1)
        return
      }
      if (this.value.trim() !== "" || this.upImgList.length > 0 || this.upVideoList.length > 0) {
        Dialog.confirm({
          message: '将此次编辑保留？',
          cancelButtonText: "不保留",
          confirmButtonText: "保留",
        })
          .then(() => {
            const drafts = {
              value: this.value,
              upImgList: this.upImgList,
              upVideoList: this.upVideoList,
              topics: this.myTopic,
              partitionInfo:this.partitionInfo.item
            }
            localStorage.setItem('drafts_dt', JSON.stringify(drafts))
            this.$router.go(-1)
          })
          .catch(() => {
            this.$router.go(-1)
            localStorage.removeItem('drafts_dt')
          });
      } else {
        this.$router.go(-1)

      }
    },
    releaseClick() {
      if (this.$store.state.postingFlag) {
        if (this.brush) {
          this.brush = false;
          // if (this.value.trim() == "") {
          //   Toast("内容不能为空");
          //   this.brush = true;
          //   return;
          // }
          if (this.partitionInfo.item == "") {
            Toast("请選擇發布位置");
            this.brush = true;
            return;
          }
          // 钢岚分享 过来的 需要验证 （tz_title） 不能为空
          // if (this.isGlShare) {
          //   if (this.tz_title.trim() === '') {
          //     Toast('标题不能为空')
          //     this.brush = true;
          //     return;
          //   }
          // }
          this.loadingFlag = true;
          let subjectIdArr = "";
          this.myTopic.forEach((item, index) => {
            if (subjectIdArr == "") {
              subjectIdArr = `${item.id}`;
            } else {
              subjectIdArr = `${subjectIdArr},${item.id}`;
            }
          });
          let imgArr = [];
          this.upImgList.forEach((item, index) => {
            imgArr[index] = { path: item.path };
          });
          let videoArr = [];
          this.upVideoList.forEach((item, index) => {
            videoArr[index] = { path: item.path };
          });
          let obj = {
            id: this.isEdit ? this.$route.query.postId : '',
            title: this.tz_title,
            description: "",
            content: this.value,
            pictures: this.upImgList.length == 0 ? "" : JSON.stringify(imgArr),
            videos:
              this.upVideoList.length == 0 ? "" : JSON.stringify(videoArr),
            // subjectIds: subjectIdArr,
            partitionId : this.partitionInfo.item.id
          };
          console.log(obj)
          // return
          // 编辑帖子
          if (this.isEdit) {
            get
              .topicEdit(qs.stringify(obj))
              .then((res) => {
                let data = res.data;
                if (data.code == 0) {
                  this.$store.commit("changetipFlag", true);
                  setTimeout(() => {
                    this.$store.commit("changetipFlag", false);
                  }, 2000);
                  this.publickStatus = 1;
                  this.$store.commit("changeRefresh", true);
                  setTimeout(() => {
                    this.$router.go(-1);
                    this.brush = true;
                  }, 100);
                  this.loadingFlag = false;
                } else {
                  this.loadingFlag = false;
                  this.publickStatus = 0;
                  let code = data.code;
                  let voteErr = _code.code.vote;
                  let msg = voteErr[code]
                    ? voteErr[code]
                    : voteErr["other"] + code;
                  Toast(msg);
                  this.brush = true;
                }
                //回调sdk 分享成功或失败
                // if (sysname === $const.ANDROID || sysname === $const.IPHONE) {
                //   if (iosVersion == "1.2" || iosVersion >= "2.0") {
                //     location.href = "iosn://pd_actv_bbs_share?status="+this.publickStatus;
                //   } else {
                //     window.pd.onBindMobileSuccess && window.pd.onBindMobileSuccess(mobile.value);
                //   }
                // } else if (sysname === $const.U3D_WEB || sysname === $const.U3D_PC) {
                //   window.onBindMobileSuccess();
                // }
              })
              .catch(() => {
                this.loadingFlag = false;
                this.brush = true;
              });

          } else {
            get
              .topicPost(qs.stringify(obj))
              .then((res) => {
                let data = res.data;
                if (data.code == 0) {
                  this.$store.commit("changetipFlag", true);
                  setTimeout(() => {
                    this.$store.commit("changetipFlag", false);
                  }, 2000);
                  this.publickStatus = 1;
                  this.$store.commit("changeRefresh", true);
                  setTimeout(() => {
                    this.$router.push({
                      name: "glPainting",
                    });
                    this.brush = true;
                  }, 100);
                  this.loadingFlag = false;
                } else {
                  this.loadingFlag = false;
                  this.publickStatus = 0;
                  let code = data.code;
                  let voteErr = _code.code.vote;
                  let msg = voteErr[code]
                    ? voteErr[code]
                    : voteErr["other"] + code;
                  Toast(msg);
                  this.brush = true;
                }
                //回调sdk 分享成功或失败
                // if (sysname === $const.ANDROID || sysname === $const.IPHONE) {
                //   if (iosVersion == "1.2" || iosVersion >= "2.0") {
                //     location.href = "iosn://pd_actv_bbs_share?status="+this.publickStatus;
                //   } else {
                //     window.pd.onBindMobileSuccess && window.pd.onBindMobileSuccess(mobile.value);
                //   }
                // } else if (sysname === $const.U3D_WEB || sysname === $const.U3D_PC) {
                //   window.onBindMobileSuccess();
                // }
              })
              .catch(() => {
                this.loadingFlag = false;
                this.brush = true;
              });
          }

        }
      } else {
        Toast("功能维护中，暂不支持发帖");
      }
    },
    emojiClick() {
      this.emojiFlag = !this.emojiFlag;
    },

    //新增话题
    addmyTopic(_item, fun) {
      let next = true;
      this.myTopic.forEach((item, index) => {
        if (item.id == _item.id) {
          next = false;
        }
      });
      if (next) {
        location.href = "#firstAnchor";
        if (this.myTopic.indexOf(_item) != -1) return;
        this.myTopic.push(_item);
        if (this.myTopic.length >= 3) {
          this.topicFlag = false;
        }
      }
      if (fun) {
        fun();
      }
    },
    //删除话题
    deteltopic(curitem) {
      this.myTopic.forEach((item, index) => {
        if (item.subjectName == curitem.subjectName) {
          this.myTopic.splice(index, 1);
        }
      });
      if (this.myTopic.length < 3) {
        this.topicFlag = true;
      }
    },
    gotopic(e) {
      if(this.changePartitionFlag){
        this.flag = e;
      }
    },

    //图片视频上传
    addFile(e, bottom) {
      
      if (bottom) {
        location.href = "#firstAnchor";
      }
      let _this = this;

      // eslint-disable-next-line no-undef
      var par = $(this).parent();
      var file = e.target.files[0];
      var indexNum = file.name.lastIndexOf(".");
      var lastName = file.name.substr(indexNum + 1);
      // console.log('file.name:', file.name)
      // console.log('indexNum:', indexNum)
      // console.log('lastName:', lastName)
      var nameArr = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "GIF",
        "JPG",
        "PNG",
        "MP4",
        "mp4",
        "MOV",
        'mov'
      ];

      // 新版本的sdk 打开上传视频
      var imgNameArr = ["gif", "jpg","jpeg","png"]
      if (!this.$store.state.isUpVideoShow) {
        if (!imgNameArr.includes(lastName)) {
          _this.file1 = 'text'
          setTimeout(function () {
            _this.file1 = "file";
          }, 30);
          Dialog.alert({
              message: "请选择正确的图片格式",
            });
            return
        }
      }

      var imgFlag = false;
      for (var i = 0; i < nameArr.length; i++) {
        if (lastName == nameArr[i]) {
          imgFlag = true;
          if (lastName.toLowerCase() === "mp4" || lastName.toLowerCase() === "mov" ) {
            // alert();
            console.log(file.name)
            // console.log()
            this.uploadType = 2;
          } else {
            this.uploadType = 1;
          }
        }
      }
      setTimeout(function () {
        if (this.uploadType === 1 && (file.size / (1024 * 1024)).toFixed(3) <= 15) {
          Dialog.alert({
              message: "图片太大啦！请选择15M以内的图片上传",
            });
            _this.file1 = "text";
            setTimeout(function () {
              _this.file1 = "file";
            }, 30);
            return
        }
        if (this.uploadType === 2 && (file.size / (1024 * 1024)).toFixed(3) <= 2*1024) {
          Dialog.alert({
              message: "视频太大啦！请选择2G以内的视频上传",
            });
            _this.file1 = "text";
            setTimeout(function () {
              _this.file1 = "file";
            }, 30);
            return
        }
        if (imgFlag) {
          // if (_this.uploadType === 2) {
            // file.newName = "_" + +new Date() + "." + 'mp4';
          // } else {
            file.newName = "_" + +new Date() + "." + lastName;
          // }
            try {
              file &&
                _this.uploadFile(
                  file,
                  function (err, data) {
                    if (data) {
                      if (_this.uploadType === 1) {
                        if (location.host.includes('zlongame')) {
                          _this.imgArry.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.zlongame.com/pressure"
                          );
                        } else if (location.host.includes('sugarfungame')) {
                          _this.imgArry.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.sugarfungame.com/pressure"
                          );
                        }
                        _this.imgArry.mindetail = `${_this.imgArry.detail}${_this.$store.state.imgThumb}`;
                        _this.imgArry.path = `${_this.imgArry.detail}`;
                        _this.imgArry.id = _this.upImgList.length;
                        _this.upImgList.push(_this.imgArry);
                        _this.$previewRefresh();
                        let curImgObj = new Image();
                        curImgObj.onload = function () {
                          // console.log("这里是当前图片加载完成了");
                          _this.loadingFlag = false;
                        };

                        curImgObj.onerror = function (err) {
                          console.log("加载出错了", err);
                        };
                        curImgObj.src = _this.imgArry.mindetail;
                        _this.imgArry = {};
                        _this.file1 = "text";
                        setTimeout(function () {
                          _this.file1 = "file";
                        }, 30);
                        // console.log("图片信息", data);
                        par.attr("url", data.url);
                      } else if (_this.uploadType === 2) {
                        // console.log(file.newName)
                        if (location.host.includes('zlongame')) {
                          _this.videoArray.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.zlongame.com"
                          );
                        } else if (location.host.includes('sugarfungame')) {
                          _this.videoArray.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.sugarfungame.com"
                          );
                        }
                        _this.videoArray.path = _this.videoArray.detail;
                        _this.videoArray.id = 1;
                        _this.upVideoList.push(_this.videoArray);
                        _this.$previewRefresh();
                        _this.loadingFlag = false;
                      }
                    } else {
                      Dialog.alert({
                        message: err,
                      });
                    }
                  },
                  par
                );
            } catch (err) {
              Dialog.alert({
                message: err,
              });
            }
          // }
        } else {
          Dialog.alert({
            message: "不支持该文件格式，请选择PNG、JPG、MP4、MOV格式上传",
          });
        }
      }, 600);
    },
    // 计算签名
    getAuthorization(options, callback) {
      get.getCosTemToken().then((res) => {
        var data;
        try {
          data = new Function("return " + JSON.stringify(res.data.data))();
          this.allowPrefix = data.allowPrefix;
          this.Region = data.region;
          this.Bucket = data.bucketName;
        } catch (res) {}
        if (data) {
          callback(null, {
            XCosSecurityToken: data.credentials.sessionToken,
            Authorization: CosAuth({
              SecretId: data.credentials.tmpSecretId,
              SecretKey: data.credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname,
            }),
          });
        } else {
          callback("获取签名出错");
          this.loadingFlag = false;
        }
      });
    },
    uploadFile(file, callback, obj) {
      // 蒙层
      this.loadingFlag = true;
      var self = this;
      var Key =
        // self.allowPrefix +
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        file.newName; // 这里指定上传目录和文件名
      self.getAuthorization(
        { Method: "PUT", Pathname: "/" + Key },
        function (err, info) {
          if (err) {
            alert(err);
            return;
          }
          let prefix =
            self.protocol +
            "//" +
            self.Bucket +
            ".cos." +
            self.Region +
            ".myqcloud.com/";
          var auth = info.Authorization;
          var XCosSecurityToken = info.XCosSecurityToken;
          var url =
            prefix +
            self.allowPrefix +
            self.camSafeUrlEncode(Key).replace(/%2F/g, "/");
          var xhr = new XMLHttpRequest();
          xhr.open("PUT", url, true);
          xhr.setRequestHeader("Authorization", auth);
          if (self.uploadType === 1) {
            xhr.setRequestHeader(
              "Pic-Operations",
              JSON.stringify({
                is_pic_info: 1,
                rules: [
                  {
                    fileid: "/pressure/" + Key,
                    rule: "imageMogr2/format/webp",
                  },
                ],
              })
            );
          }

          XCosSecurityToken &&
            xhr.setRequestHeader("x-cos-security-token", XCosSecurityToken);
          xhr.upload.onprogress = function (e) {
            if (obj) {
            }
          };
          xhr.onload = function () {
            if (xhr.status === 200 || xhr.status === 206) {
              var ETag = xhr.getResponseHeader("etag");
              callback(null, { url: url, ETag: ETag });
            } else {
              callback("上传失败，状态码：" + xhr.status);
            }
          };
          xhr.onerror = function () {
            callback("上传失败，请检查是否配置跨域规则");
          };
          xhr.send(file);
        }
      );
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A");
    },
    removeFile(num, type) {
      let _this = this;
      let fileDataStr = type === "img" ? "upImgList" : "upVideoList";
      // console.log(num, fileDataStr);
      _this[fileDataStr].forEach((item, index) => {
        if (item.id == num) {
          _this[fileDataStr].splice(index, 1);
        }
      });
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.uploadPage h1 {
  font-size: 0.5rem;
  text-align: center;

  .uploadPage_toptitle {
    background: red;
  }
}

.check-img {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 60%;
  }
}


// .gl {
.ipad {
  .link_icon {
    display: none;
  }

  .details_top_title {
    color: #2c3a45;
    font-size: 0.28rem;
  }

  .rich {
    position: absolute;
    right: 0;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      width: 0.32rem;
      height: 0.31rem;
      background: url(../../assets/img/rich/rich_icon.png);
      background-size: 100% 100%;
      left: -0.4rem;
    }
  }
}

.van-icon-arrow-left {
  background-image: url(../../assets/img/rich/back.png);
  color: #000;
}
.van-icon-close {
  color: #23323d
}


.lzg,
.dqss {
  .van-icon-arrow-left {
    background-image: none;
  }
}

.uploadPage .content_input {
  margin-top: 0;
}

.video_icon {
  width: 0.61rem;
  height: 0.46rem;
  background: url(../../assets/img/rich/video_icon.png);
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  opacity: 0.6;
  cursor: pointer;
}

.uploadPage_toptitle {
  background-color: #f5f5f5;

  .details_top_title {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .link {
    font-size: 0.28rem;
    color: #2c3a45;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.dt {
      margin-right: 0.6rem;
    }

    .link_icon {
      width: 0.26rem;
      height: 0.1rem;
      background: url(../../assets/img/rich/arrow.png);
      background-size: 100% 100%;
    }
  }
}

// }

.videoList {
  width: 100%;
  height: 100%;
  margin: 0 .2rem;
}

.upload_tip {
  text-align: center;
  color: #a6a8ad;
  font-size: 0.22rem;
  bottom: 0.4rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.van-sticky {
  display: none !important;
}
.lhlr {
  .uploadPage_toptitle {
    .link {
      color: #fff;
    }
  }
}
</style>

<!-- https://qa-community.tentree-games.com/index.html?appkey=1705460260139&balance=4940&channelId=1000000002&clientVersion=1.0.5&customparams=%7B%22headId%22%3A%221%22%7D&device=942bb43aa4514092925d532b14e508cf&ecid=3010011001&gameClientVersion=1.0.5&logintype=guest&packagename=com.tentree.ios.mecharashi&partyname=&roleid=1126947219875970716&rolelevel=23&rolename=%E5%B0%8F%E5%B8%85%E4%B8%8D%E8%A6%81%E8%84%B8&serverid=2001&servername=qa&sign=cbef776e9fbccf4ccc41562e81c52446&t=1710321468000&token=48C15874529E497FAB1B43D38E0476A869530EBDEC7888E21B4B4236A523583C2BF4607F5EF7ABC428AFBE5186CF262DB96EC906A4F6F9980CE5CAD10AAA75319AE5609826E72DD7&userid=8019100000000210000635076&viplevel=0&horizontalOffset=0&verticalOffset=0&verticalOffset2=20#/postPage?imgUrl=https%3A%2F%2Ftongren-1251257918.cos.ap-shanghai.myqcloud.com%2F1705460260139%2Fsns%2F2AA61D27-1743-4C7D-8790-0652DDB2D7B2-8019100000000210000635076-1126947219875970716-942bb43aa4514092925d532b14e508cf.png&para=GaragePaintingCode&text=%E5%88%86%E4%BA%A -->
